<template>
	
	<div>
		
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		
		<div class="container">
			
			<Breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></Breadcrumbs>
            <h1>event detail page</h1>
            <EventCarousel :slides="eventCarousel.slides"></EventCarousel>
            <FileUpload></FileUpload>
		</div>
		
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>

	</div>
	
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
    import Breadcrumbs from '../components/Global/Breadcrumbs.vue';
    import FileUpload from '../components/Global/FileUpload.vue';
    import EventCarousel from '../components/Events/EventCarousel.vue';
	import Footer from '../components/Footer/Footer.vue';

	import axios from 'axios';
	
	export default {
		name: 'EventDetailPage',
		
		components: {
			Header,
            Breadcrumbs,
            FileUpload,
            EventCarousel,
			Footer
		},
		
		data() {
			return {
                breadcrumbs: [],

				header: {
					utilityNav: {},
					siteNavigation: {}
                },
                eventCarousel: {
                    slides: []
                },
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let endpointID = this.$el.parentElement.getAttribute('data-endpoint-id');
			if (endpointID) {
				
				let endpoint = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/' + endpointID + '.json';
	
				axios.get(endpoint).then(function(response) {
					
                    self.breadcrumbs = response.data.breadcrumbs;
                    self.eventCarousel.slides = response.data.slides;
				})
				.catch(function (error) {
					console.log(error);
				});
			}
			
			let footer = location.protocol + '//' + window.location.host + this.$projectRoot + '/SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>